import { usePaymentOptionsForDiscountConfigurationQuery } from '../promotionsApi';

export function useGetPaymentOptionsForDiscountConfiguration() {
  const {
    data: paymentOptions = [],
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = usePaymentOptionsForDiscountConfigurationQuery();

  return {
    isLoading,
    isError,
    isSuccess,
    paymentOptions,
    reload: refetch,
  };
}
